import { render, staticRenderFns } from "./TrBookIndexMainLink.vue?vue&type=template&id=0fffa15d&scoped=true&"
import script from "./TrBookIndexMainLink.vue?vue&type=script&lang=js&"
export * from "./TrBookIndexMainLink.vue?vue&type=script&lang=js&"
import style0 from "./TrBookIndexMainLink.vue?vue&type=style&index=0&id=0fffa15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffa15d",
  null
  
)

export default component.exports